var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoShareInfo)?_c('page-material-study',{attrs:{"user":_vm.user,"videoShareInfo":_vm.videoShareInfo,"is-phone":"isPhone","tmId":_vm.tmId,"videoId":_vm.videoId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }